import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import RoutePlanForm from './routePlanForm';
import { useRoutePlans } from '../apiHooks';
import utils from '../../utils/utils';
import DATE_FORMAT from '../../components/constants/dateFormat';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import { Redirect } from 'react-router';
import RoutePlanPreview from './routePlanPreview';

const RoutePlannerPlans = ({ match }) => {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [editRoutePlan, setEditRoutePlan] = useState(null);

  const deliveryDate = match.params.date ? utils.getDateFromString(match.params.date, DATE_FORMAT.url) : null;

  const { result, isLoading, isError, error } = useRoutePlans({
    deliveryDate: deliveryDate?.format(DATE_FORMAT.dataTransfer),
  });

  if (!deliveryDate) {
    return <Redirect to={`/routePlanner/date/${utils.getNowDate().format(DATE_FORMAT.url)}`} />;
  }

  // TODO enable businessProfile usage & setup
  // TODO enable delivery imports via spreadsheets
  // TODO add driver creation for organisation

  return (
    <>
      <div className="route-planner-index">
        <h2 className="m-b-3">
          <FormattedMessage id={'route.planner.index.header'} />
        </h2>

        {deliveryDate ? <div className="m-b-3">🗓 {deliveryDate?.format(DATE_FORMAT.displayWeekdayAndDate)}</div> : ''}

        <div className="m-b-6">
          <button className="btn btn-primary" onClick={() => setShowCreateForm(true)}>
            <FontAwesomeIcon icon={faPlusCircle} /> <FormattedMessage id={'route.planner.index.cta.create'} />
          </button>
        </div>

        <Loader show={isLoading} />
        {isError ? <ErrorMessage error={utils.getErrorMessageFromResponse(error)} /> : ''}

        {result?.routePlans ? (
          result.routePlans.length ? (
            <div className="row m-b-6">
              <div className="col-12 col-xl-6">
                {result?.routePlans.map((routePlan) => (
                  <RoutePlanPreview key={routePlan.id} routePlan={routePlan} setEditRoutePlan={setEditRoutePlan} />
                ))}
              </div>
            </div>
          ) : (
            <p>
              <FormattedMessage id={'route.planner.plans.empty'} />
            </p>
          )
        ) : (
          ''
        )}
      </div>

      <Modal show={!!editRoutePlan} onHide={() => setEditRoutePlan(null)} size="lg">
        <div onClick={() => setEditRoutePlan(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {editRoutePlan ? (
            <RoutePlanForm routePlanId={editRoutePlan.id} onSuccess={() => setEditRoutePlan(null)} />
          ) : (
            ''
          )}
        </div>
      </Modal>

      <Modal show={!!showCreateForm} onHide={() => setShowCreateForm(false)} size="lg">
        <div onClick={() => setShowCreateForm(false)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {showCreateForm ? (
            <RoutePlanForm onSuccess={() => setShowCreateForm(false)} dateParam={match.params.date} />
          ) : (
            ''
          )}
        </div>
      </Modal>
    </>
  );
};

RoutePlannerPlans.propTypes = {
  currentUser: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default connect(mapStateToProps)(RoutePlannerPlans);
